/**
 * The two proposals on the customer's "Serviceförslag" step. "Trafiksäker" is
 * the work that has to be done now; "Toppskick" adds what could wait.
 */
export enum ProposalLevel {
  TRAFFIC_SAFE = "TRAFFIC_SAFE",
  TOP_CONDITION = "TOP_CONDITION",
}

/**
 * What the customer approves on a proposal with levels: one of the two
 * presets as sent, or "Anpassad service" — Toppskick with what they took out
 * in "Anpassa service".
 */
export enum ProposalServiceChoice {
  TOP_CONDITION = "TOP_CONDITION",
  TRAFFIC_SAFE = "TRAFFIC_SAFE",
  CUSTOM = "CUSTOM",
}
